import {
  B_14,
  BANNER_DEFAULTS,
  hideB14Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const B14_PLASMIC_PROPS = {
  b14Heading: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_14].heading,
    description: "Main heading (B14 only)",
    hidden: hideB14Props,
  },
  b14Description: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_14].description,
    description: "Description text (B14 only)",
    hidden: hideB14Props,
  },
  b14PrimaryButtonText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_14].primaryButtonText,
    description: "Primary CTA button text (B14 only)",
    hidden: hideB14Props,
  },
  b14PrimaryButtonUrl: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_14].primaryButtonUrl,
    description: "Primary CTA button URL (B14 only)",
    hidden: hideB14Props,
  },
  b14Image: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_14].image,
    description: "Mobile/tablet image (B14 only)",
    hidden: hideB14Props,
  },
  b14ImageAlt: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_14].imageAlt,
    description: "Image alt text (B14 only)",
    hidden: hideB14Props,
  },
};
